<template>
    <div v-show="step == stepKey" :key="stepKey">
        <slot></slot>
    </div>
</template>

<script>
    import objectFitPolyfill from '@/utils/object-fit';

    export default {
        inject: ['EventBus'],
        data() {
            return {
                step: 1
            };
        }, 
        mounted() {
            var vm = this;

            window.scrollTo({ top: 0, behavior: 'smooth' });

            this.EventBus.$on('stepChanged', function(step, inputs) {

                if(vm.$el.nodeName !== '#comment' && step !== vm.stepKey) {
                    vm.$el.classList.add('fade-leave-active', 'fade-leave-to');
                }

                setTimeout(() => {
                    vm.step = step;
                    this.$nextTick(() => {
                        if(vm.$el.nodeName !== '#comment' && step === vm.stepKey) {
                            vm.$el.classList.add('fade-enter', 'fade-enter-active');
                            vm.$el.classList.remove('fade-enter');
                            vm.EventBus.$emit('stepShown', inputs);
                            setTimeout(() => {
                                objectFitPolyfill();
                            }, 150);
                        }  else {
                            vm.$el.classList.remove('fade-leave-to');
                        }
                    });
                }, 10);
            });
        },
        props: {
            stepKey: {
                type: Number,
                required: true
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/app/components/aha-transition-step.vue